import React from "react";
import type { Project } from "../../../graphql-client/codegen-types";
import AIToolsBlock from "../../components/AIToolsBlock";
import { getVerifyCharterPrompt } from "./ai-prompts";

type Props = {
  project: Project;
};

const AIPrompt2Block = ({ project }: Props) => (
  <AIToolsBlock
    title="Herramientas de IA para el Paso 1"
    subtitle="Usa este prompt para evaluar el Charter de tu proyecto."
    prompts={[getVerifyCharterPrompt(project)]}
    firstNumber={2}
  />
);

export default AIPrompt2Block;
